// NOTE
// Please use your own firebase details below. For more details visit: https://pixinvent.com/demo/vuexy-vuejs-admin-dashboard-template/documentation/development/firebaseIntegration.html

import firebase from "firebase/app";
import "firebase/firestore";
// Initialize Firebase
const config = {
  apiKey: "AIzaSyBMWmGkqgN1V5Mab-8WB5rmlanF8LrXn2o",
  authDomain: "mallaventuradirect.firebaseapp.com",
  databaseURL: "https://mallaventuradirect.firebaseio.com",
  projectId: "mallaventuradirect",
  storageBucket: "mallaventuradirect.appspot.com",
  messagingSenderId: "179504153952",
  appId: "1:179504153952:web:e9aaea625cd734833d8a05"
};

firebase.initializeApp(config);
export let firestore = firebase.firestore();
